<div class="row" [hidden]="aliases?.length == 0">
  <div class="col-xs-12">
    @if (aliases && aliases?.length) {
      <p-table
        [value]="aliases"
        [totalRecords]="totalRecords"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [showCurrentPageReport]="true"
        selectionMode="single"
        [(selection)]="selectedAlias"
        (onRowSelect)="onRowSelect($event)"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        stateStorage="session"
        stateKey="state-session-active-plan-aliases"
        >
        <ng-template pTemplate="header">
          <tr>
            @for (key of keys; track key) {
              <th pSortableColumn="{{ key }}">
                {{ locationTableConfig?.columns[key]?.title }} <p-sortIcon field="{{ key }}"></p-sortIcon>
              </th>
            }
          </tr>
          <tr>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="plan_name"
                [placeholder]="placeholders['plan_name']"
                ariaLabel="Filter plan_name"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="organization"
                [placeholder]="placeholders['organization']"
                ariaLabel="Filter organization"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="matched_at"
                [placeholder]="placeholders['matched_at']"
                ariaLabel="Filter matched at"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-alias>
          <tr [pSelectableRow]="alias">
            @for (key of keys; track key) {
              <td>{{ alias?.[key] }}</td>
            }
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
</div>

<div [hidden]="aliases?.length > 0">
  <div class="empty-state">
    <div class="empty-state-content">
      <span>No plan aliases for this plan</span>
      <br />
      <a routerLink="/payer/plans" [queryParams]="{selectTab: 1}">View pending plans</a>
    </div>
  </div>
</div>
